import { InspectionTypeOverrides } from 'types'

const aerospaceOverride: InspectionTypeOverrides = {
  feature: {
    annotationFormButton: {
      formType: '781A',
    },
    aircraftMetadata: true,
    primitiveGeometryAsAnnotation: false,
  },
  annotationForm: {
    showDamageTypeSelector: true,
    annotationMenuScrollable: true,
  },
}

export default aerospaceOverride
